import { render } from "./InventoryExtraQuantityModal.vue?vue&type=template&id=210616eb"
import script from "./InventoryExtraQuantityModal.vue?vue&type=script&lang=js"
export * from "./InventoryExtraQuantityModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__